import React, { useContext, createContext, } from 'react';
import { IN_PROGRESS, } from '../../../../constants/statuses';
export const DEFAULT_INSPECTION_LIST_SCOPE = 'my-inspections';
export const DEFAULT_INSPECTION_LIST_STATUS = IN_PROGRESS;
const InspectionListingContext = createContext({
    canViewTeamInspections: false,
    scope: DEFAULT_INSPECTION_LIST_SCOPE,
    status: DEFAULT_INSPECTION_LIST_STATUS,
    onInspectionsMutated: undefined,
});
export const InspectionListingProvider = ({ children, value }) => (React.createElement(InspectionListingContext.Provider, { value: value }, children));
export const useInspectionListingContext = () => useContext(InspectionListingContext);
